import React from 'react'
import { Select as AppSelect, FormInstance, FormRuleObject, Typography, SelectProps, SizeType } from '@commutifi-fe/ui'
import { useIntl } from 'locales/index'

const { Text } = Typography

export interface ISelectOption {
  value: string
  label?: string
  disabled?: boolean
  selected?: boolean
}

export interface ISelectInputProps extends FormInstance {
  options: ISelectOption[]
  placeholder?: string | React.ReactNode
  name?: string
  size?: SizeType
  validateStatus?: string | string[]
  help?: string | string[] | true
  layout?: {
    labelCol?: Record<string, unknown>
    wrapperCol?: Record<string, unknown>
    className?: string
  }
  rules?: FormRuleObject[]
  loading?: boolean
  disabled?: boolean
  allowClear?: boolean
  // Antd form item id
  id?: string
  value?: {
    value: string
  }
  onChange?: (e: any) => void
  showDropdownOptionsCount?: boolean
}

function SelectInput({
  placeholder,
  size,
  disabled,
  options,
  id,
  value: currentOption,
  loading,
  onChange,
  allowClear,
  showDropdownOptionsCount
}: ISelectInputProps) {
  const intl = useIntl()
  const handleChange = (value: string) => {
    const optionsSelected = options.filter((option) => option.value === value)
    return onChange ? onChange(optionsSelected[0].value) : null
  }

  const selectPropsComputed: Partial<SelectProps> = {
    placeholder,
    loading,
    disabled,
    size,
    allowClear,
    id,
    value: currentOption,
    onChange: handleChange
  }

  return (
    <>
      <AppSelect
        {...selectPropsComputed}
        options={options.map((option) => ({
          key: option.value,
          value: option.value,
          label: option.label || option.value,
          disabled: option.disabled
        }))}
      />
      {showDropdownOptionsCount ? (
        <Text type="secondary" className="u-margin-top--tiny">
          {intl.formatMessage({ id: 'global.dropdown.options.count' }, { count: options.length })}
        </Text>
      ) : null}
    </>
  )
}

export default SelectInput
